import { FC } from 'react';
import { Button, ButtonGroup } from '@chakra-ui/react';

import { Dialog } from '../Dialog.component';
import { UseConfirmDialogReturn } from './types/useConfirmDialogReturn';

export const ConfirmDialog: FC<UseConfirmDialogReturn> = ({
  open,
  options,
  onClose,
  onConfirm,
}) => {
  if (!options) return null;

  return (
    <Dialog
      footer={
        <ButtonGroup>
          <Button onClick={onClose}>Cancel</Button>
          <Button {...options.confirmButtonProps} onClick={onConfirm}>
            Continue
          </Button>
        </ButtonGroup>
      }
      header={options.title}
      onOpenChange={onClose}
      open={open}
      role="alertdialog"
      showCloseButton={false}
    >
      {options.message}
    </Dialog>
  );
};
